module.exports = __webpack_public_path__ + "static/img/top-app.069163e8.png";